const getFeaturesList = (intl) => [
  // ALL PLANS
  {
    title: intl.formatMessage({
      defaultMessage: 'Record and edit studio-quality audio',
    }),
    content: intl.formatMessage({
      defaultMessage:
        'Unlimited hours of studio-quality audio and editing. Record remotely with co-hosts and guests in separate tracks, plus access to music, effects, and audio enhancement. Powered by Podcastle.',
    }),
    planType: 'all',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'Distribution to every podcast app',
    }),
    content: intl.formatMessage({
      defaultMessage:
        'Get your show into every podcast app, including Apple Podcasts, Spotify, Amazon Music, Pocket Casts, and Castbox. Includes your own free RSS feed.',
    }),
    planType: 'all',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'Switch quickly and easily to Acast from another host',
    }),
    content: intl.formatMessage({
      defaultMessage:
        "Move your podcast and all your episodes to Acast quickly, simply, and free. Your listeners don't have to do anything and won't notice any changes",
    }),
    planType: 'all',
  },
  {
    title: intl.formatMessage({
      defaultMessage: 'Make money with ads',
    }),
    content: intl.formatMessage({
      defaultMessage:
        "Monetize through ads from thousands of reputable brands. Acast's advertising marketplace puts you in control of monetizing your content. Eligibility criteria apply.",
    }),
    planType: 'all',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Advanced podcast analytics' }),
    content: intl.formatMessage({
      defaultMessage:
        "IAB-certified stats to help you understand your podcast's performance and make smarter decisions. Includes downloads, unique listeners, episode performance, geography, app listens, and web player data.",
    }),
    planType: 'all',
  },

  // STARTER PLAN
  {
    title: intl.formatMessage({ defaultMessage: 'One show with up to 5 episodes*' }),
    content: intl.formatMessage({
      defaultMessage:
        "Create or import your podcast and publish up to 5 episodes with unlimited listener downloads. *Get unlimited episodes when you make your show available in Acast's advertising marketplace.",
    }),
    planType: 'starter',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Basic podcast website' }),
    content: intl.formatMessage({
      defaultMessage:
        'A website designed for you and your podcast. Optimized for mobile and search engine discovery.',
    }),
    planType: 'starter',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Basic embeddable web player' }),
    content: intl.formatMessage({
      defaultMessage:
        'A sleek web player for your episodes and show that can be embedded on your website, blog, and social media',
    }),
    planType: 'starter',
  },

  // INFLUENCER PLAN
  {
    title: intl.formatMessage({ defaultMessage: 'Multiple shows with unlimited episodes' }),
    content: intl.formatMessage({
      defaultMessage:
        'Host multiple shows and publish unlimited episodes with no download limits. ',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Monetization with sponsorships' }),
    content: intl.formatMessage({
      defaultMessage:
        "Get access to sponsorship opportunities from thousands of reputable brands. Acast's advertising marketplace puts you in control of monetizing your content.",
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Dynamic intros and outros' }),
    content: intl.formatMessage({
      defaultMessage:
        'Effortlessly add and change dynamic short audio intros and outros to all your episodes. Perfect for promoting your current offers or adding your unique audio signature.',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Headliner audio-to-video integration' }),
    content: intl.formatMessage({
      defaultMessage:
        'Easily create videos to promote your podcast directly from your Acast dashboard. Share to Instagram, Facebook, X, YouTube, Linkedin, and anywhere video lives.',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Customizable website for your podcast' }),
    content: intl.formatMessage({
      defaultMessage:
        'A beautiful, customizable website designed for you and your podcast. Optimized for mobile and search engine discovery.',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Obfuscate Email (Spam filter)' }),
    content: intl.formatMessage({
      defaultMessage:
        'Protect your email address in your RSS feed and let Acast handle spam filtering, keeping your inbox clean.',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Webhooks' }),
    content: intl.formatMessage({
      defaultMessage:
        'Automate actions when you publish an episode using WebHooks. Trigger social media posts, message your Discord community, update your podcast planner, and anything else your coding skills can make happen.',
    }),
    planType: 'influencer',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Episode transcripts' }),
    content: intl.formatMessage({
      defaultMessage:
        'Get full episode transcripts in minutes, available in 8 languages: English, French, German, Spanish, Italian, Dutch, Swedish, and Norwegian.',
    }),
    planType: 'influencer',
  },

  // ACE PLAN
  {
    title: intl.formatMessage({ defaultMessage: 'Team and Network Management' }),
    content: intl.formatMessage({
      defaultMessage:
        'Take control of your podcast business, manage access to your network and shows by setting team permissions.',
    }),
    planType: 'ace',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Prioritized support' }),
    content: intl.formatMessage({
      defaultMessage:
        'Get prioritized support in multiple languages, including English, Spanish, Swedish, French, and German.',
    }),
    planType: 'ace',
  },
  {
    title: intl.formatMessage({ defaultMessage: 'Publishing API' }),
    content: intl.formatMessage({
      defaultMessage:
        'Enable API calls to request show and episode information, as well as create, update and delete episodes.',
    }),
    planType: 'ace',
  },
];

const getFeaturesDescription = (intl) => ({
  starter: {
    description: intl.formatMessage({
      defaultMessage:
        'All the essential tools to get started with a podcast or try out Acast. No strings attached.',
    }),
    featuresDescription: intl.formatMessage({
      defaultMessage: 'Includes:',
    }),
    features: getFeaturesList(intl).filter((feature) => feature.planType === 'starter'),
  },
  influencer: {
    recommended: true,
    description: intl.formatMessage({
      defaultMessage: 'Reach a wider audience and grow your podcast further.',
    }),
    featuresDescription: intl.formatMessage({
      defaultMessage: 'Includes everything from the Starter plan, plus:',
    }),
    features: getFeaturesList(intl).filter((feature) => feature.planType === 'influencer'),
  },
  ace: {
    description: intl.formatMessage({
      defaultMessage:
        'Set-up the systems for you and your team to produce and distribute podcasts at scale.',
    }),
    featuresDescription: intl.formatMessage({
      defaultMessage: 'Includes everything from the Influencer plan, plus:',
    }),
    features: getFeaturesList(intl).filter((feature) => feature.planType === 'ace'),
  },
});

const getFilteredFeaturesList = (intl, planType) =>
  getFeaturesList(intl)
    .filter((feature) => {
      switch (planType) {
        case 'starter':
          return feature.planType === 'starter' || feature.planType === 'all';
        case 'influencer':
          return feature.planType === 'influencer' || feature.planType === 'all';
        case 'ace':
          return (
            feature.planType === 'influencer' ||
            feature.planType === 'ace' ||
            feature.planType === 'all'
          );
        case 'acast-creator-network':
          return (
            feature.planType === 'influencer' ||
            feature.planType === 'ace' ||
            feature.planType === 'all'
          );
        default:
          return false;
      }
    })
    .filter(Boolean)
    .sort((a, b) => {
      // planType "all" should be the last element
      if (a.planType === 'all') {
        return 1;
      }
      if (b.planType === 'all') {
        return -1;
      }
      return 0;
    });

export { getFeaturesDescription, getFeaturesList, getFilteredFeaturesList };
